const style = theme => ({
  content: {
    backgroundColor: 'white',
    color: 'black',
    borderLeft: '5px solid',
    borderColor: theme.palette.primary.main,
    width: '60%',
  },
  icon: {
    flex: 1,
  },
  message: {
    padding: 5,
    display: 'flex',
    alignItems: 'center',
  },
  close: {
    padding: 5,
    position: 'absolute',
    top: 0,
    right: 0,
  },
});

export default style;
